export default __webpack_public_path__ + "static/media/icn-checkbox-on-24px.ae2ed619.svg";